import Api from '../api/Api';

export const FETCH_LAST_SEARCH = 'FETCH_LAST_SEARCH';

export function setLastSearch(lastSearch) {
    return {
        type: FETCH_LAST_SEARCH,
        payload: lastSearch
    };
}

export function fetchLastSearch() {
    return (dispatch) =>
        Api.LastSearch.get().then((lastSearch) => {
            dispatch(setLastSearch(lastSearch));
            return lastSearch;
        });
}
